import styled from 'styled-components/macro';
import { CardHolder } from '../CreateProfile/CreateProfile.styles';

export const IconHolder = styled.div`
  width: 129px;
  height: 129px;
  background: linear-gradient(
    268.95deg,
    rgba(41, 37, 88, 0.536345) 4.06%,
    rgba(38, 35, 83, 0.866791) 42.35%,
    rgba(33, 30, 75, 0.50218) 99.53%
  );
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px auto;
`;

export const StyledCardHolder = styled.div`
  ${CardHolder}
`;

export const Card = styled.div`
  background: var(--bg-primary);
  max-width: 410px;
  border-radius: 10px;
  padding: 40px;
  width: 100%;
  text-align: center;

  .light & {
    background: #23204e;
  }
`;
